<script>
import Loader from "@/components/widgets/loader";

export default {
   components: {
      Loader,
   },
   props: {
      updating: {
         type: Boolean,
      },
      agencies: {
         type: Array,
            default: () => {
            return []
         },
      },
   },
};
</script>

<template>
   <Loader :loading="updating">
      <div class="card">
         <div class="card-body">
            <h4 class="card-title mb-4">Top Insurance Agency</h4>

            <div class="text-center" v-if="agencies.length">
               <div class="mb-4">
                  <i class="bx bx-check-shield text-primary display-4"></i>
               </div>
               <h3>{{agencies[0].occurrence}}</h3>
               <p>{{agencies[0].agency}}</p>
            </div>

            <div class="table-responsive mt-4">
               <table class="table table-centered">
                  <tbody v-if="agencies.length">
                     <tr v-for="(agency, index) in agencies" :key="agency.insurance_agency_id">
                        <td style="width: 140px">
                           <p class="mb-0">{{agency.agency}}</p>
                        </td>
                        <td style="width: 120px">
                           <h5 class="mb-0">{{agency.occurrence}}</h5>
                        </td>
                        <td>
                           <b-progress v-if="index==0"
                             :value="100"
                             variant="primary"
                             height="5px"
                           ></b-progress>
                           <b-progress v-if="index==1"
                             :value="100"
                             variant="success"
                             height="5px"
                           ></b-progress>
                           <b-progress v-if="index==2"
                             :value="100"
                             variant="warning"
                             height="5px"
                           ></b-progress>
                        </td>
                     </tr>
                     
                  </tbody>

                  <tbody v-else>
                     <tr>
                        <td colspan="3">No agencies found</td>
                     </tr>
                  </tbody>
               </table>
            </div>
         </div>
      </div>
   </Loader>
</template>
